import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';

/**
 * Higher-order component for scrolling to top upon mount.
 */
export default function scrollToTop(Target) {
  return /*#__PURE__*/function (_React$Component) {
    function ScrollToTop() {
      _classCallCheck(this, ScrollToTop);
      return _callSuper(this, ScrollToTop, arguments);
    }
    _inherits(ScrollToTop, _React$Component);
    return _createClass(ScrollToTop, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        window.scrollTo(0, 0);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(Target, this.props);
      }
    }]);
  }(React.Component);
}
//# sourceMappingURL=scrollToTop.js.map
